export const SHOPIFY_METAFIELDS_IDENTIFIERS = [
  {
    key: 'original_price',
    namespace: 'custom'
  },
  {
    key: 'sleep_support',
    namespace: 'custom'
  },
  {
    key: 'accessories',
    namespace: 'custom'
  },
  {
    key: 'daily_health',
    namespace: 'custom'
  },
  {
    key: 'sleep',
    namespace: 'custom'
  },
  {
    key: 'usp_rich_text',
    namespace: 'custom'
  },
  {
    key: 'url',
    namespace: 'custom'
  },
  {
    key: 'flavor_group',
    namespace: 'custom'
  },
  {
    key: 'flavor',
    namespace: 'custom'
  },
  {
    key: 'flavor_hex_code',
    namespace: 'custom'
  },
  {
    key: 'label',
    namespace: 'custom'
  },
  {
    key: 'short_description',
    namespace: 'custom'
  },
  {
    key: 'frequency_note',
    namespace: 'custom'
  },
  {
    key: 'original_price_footnote',
    namespace: 'custom'
  },
  {
    key: 'members_only',
    namespace: 'custom'
  }
];
